import React from 'react';
import { Divider } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import GalleryCardCarousel from 'components/ProductPage/GalleryCardCarousel';
import AboutTheBrand from 'components/ProductPage/AboutTheBrand/AboutTheBrand';
import ProductCardCarousel from 'components/ProductPage/ProductCardCarousel/ProductCardCarousel';
import RelatedLinks from 'components/ProductPage/RelatedLinks';
import ChanelBottomBanner from 'components/ChanelBottomBanner';
import localeUtils from 'utils/LanguageLocale';
import skuUtils from 'utils/Sku';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR);

const DiscoverySection = ({
    currentProduct, productDetails, currentSku, isSmallView, isChanel, isGiftCard, brandData
}) => {
    const isCanada = localeUtils.isCanada();

    return (
        <>
            {productDetails?.brand && skuUtils.brandShowUserGeneratedContent(productDetails.brand.brandId) && (
                <GalleryCardCarousel
                    currentProduct={currentProduct}
                    brandId={productDetails.brand.brandId}
                    skuType={currentSku?.type}
                    productId={productDetails?.productId}
                />
            )}
            <ProductCardCarousel
                carouselContextId={productDetails?.productId}
                title={getText('recentlyViewedLabel')}
                skus={currentProduct?.recentlyViewedSkus}
            />
            {!isGiftCard && !currentSku?.configurableOptions && (
                <AboutTheBrand
                    productId={productDetails?.productId}
                    {...brandData}
                />
            )}
            {isChanel && !isSmallView && (
                <>
                    <Divider />
                    <ChanelBottomBanner marginY={4} />
                </>
            )}
            <RelatedLinks
                links={isCanada ? currentProduct?.linkEquityBlock?.links : currentProduct?.relatedLinks || currentProduct?.linkEquityBlock?.links}
            />
            {isCanada && (
                <RelatedLinks
                    links={currentProduct?.relatedLinks}
                    isExploreMore={true}
                />
            )}
        </>
    );
};

export default wrapFunctionalComponent(DiscoverySection, 'DiscoverySection');
